<template>
  <v-container style="max-width:1200px" class="pt-0">
    <ASearchForm
      :modelName="'Role'"
      :create="hasEditPermission"
      :dropdownProps="[{type:'text',name: 'Name (contains)', payloadKey: 'name'}]"
      @change="search"
      @create="onCreate"
      ref="ASearchForm"
      class="mb-5"
    ></ASearchForm>
    <ADataTable
      :headers="headers"
      :api="api"
      :sortBy="'name'"
      :editAction="hasEditPermission"
      :deleteAction="hasEditPermission"
      @click:edit="onEdit"
      @click:delete="onDelete"
      :hideTitleBar="true"
      :apiParams="apiParams"
      ref="table"
    ></ADataTable>
    <AFormDialog
      ref="formDialog"
      :fields="formMeta"
      :modelName="'Role'"
      :model="'roles'"
      :updateOnlyChanged="true"
      @modified="load"
    ></AFormDialog>
  </v-container>
</template>

<script>
import roleApi from "../api/role";
import modelOneApi from "../api/modelOne";
import snackbar from "../mixins/snackbar";
import CRUDFuncsMixin from "../mixins/CRUDFuncs";
import ConfirmDialogMixin from "../mixins/ConfirmDialogMixin";
import PermissionsHelper from "../mixins/PermissionsHelper"
import ASearchForm from "../components/ASearchForm";
import ADataTable from "../components/ADataTable";
import AFormDialog from "../components/AFormDialog";

export default {
  name: "RoleManage",
  mixins: [snackbar, ConfirmDialogMixin, CRUDFuncsMixin,PermissionsHelper],
  components: {
    ASearchForm,
    ADataTable,
    AFormDialog
  },
  data() {
    return {
      model:"roles",
      headers: [
        { text: "Role Name", value: "name", width: 150 },
        {
          text: "Permissions",
          value: "permissionsComputed",
          sortable: false,
          format: {
            value: "permissions",
            formatter: array => {
              let v = "";
              array.forEach(e => {
                v = (v.length == 0 ? "" : v + ", ") + e;
              });
              return v;
            }
          }
        }
      ],
      apiParams: {},
      formMeta: [
        {
          type: "text",
          label: "Role Name*",
          queryParam: "name",
          rules: [
            v => (!!v && v.length >= 5) || "Should be atleast 5 characters"
          ],
          value: "",
          updatable: true
        },
        {
          type: "dropdown",
          multiple: true,
          label: "Permissions",
          queryParam: "permissions",
          rules: [],
          value: undefined,
          items: [],
          updatable: true
        }
      ]
    };
  },
  mounted() {
    this.fetchPermissions();
  },
  methods: {
    fetchPermissions() {
      roleApi.allPermissions(data => {
        if (data.ok) {
          this.formMeta[1].items = data.d;
        }
      });
    },
    search(payload) {
      this.apiParams = payload
    }
  }
};
</script>

